import React, {Component} from "react";
import PropTypes from 'prop-types';

import {getFlag} from "./../../cc-imports";
// import './cc-flags.css'
import './../../styles/css/components/CCFlag/cc-flag.css'

class CCFlag extends Component {

    static propTypes = {
        borderRadius:PropTypes.string,
        teamKey: PropTypes.string,
        disabled:PropTypes.bool
    }

    static defaultProps = {
        disabled : false,
    }

    render() {
        const {disabled, height,width, borderRadius} = this.props;
        return (
            <div style={this.props.style}>
                <div className={'flex-container cc-flag'} style={{...{flex:1,borderColor: '#fff',justifyContent: 'center',
                    alignItems: 'center',backgroundImage:'url('+getFlag(this.props.teamKey, disabled)+')',
                    backgroundSize:'contain',backgroundRepeat:'no-repeat'}, ...this.props.imageStyle}}>

                </div>
            </div>
        );
    }
}


export default CCFlag;


// WEBPACK FOOTER //
// ./src/app/components/CCFlag/CCFlag.js